<template>
	<b-container fluid class="dashboard">
		<b-row class="dashContent judgeView">
			<b-col md="12" v-if="resource">    
				<b-form-group label="Status" label-cols-md="2">
					<b-form-select v-model="filter.mbsdStatus" @change="doFilter">
						<b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
						<b-form-select-option value="0">Unverified</b-form-select-option>
						<b-form-select-option value="1">Verified</b-form-select-option>
					</b-form-select>
				</b-form-group>				
				<b-form-group label="E-mail Address" label-cols-md="2">
					<b-form-input v-model="search.mbsdEmail" placeholder="Email address to find" @input="doFilter"></b-form-input>
				</b-form-group>				
				<b-form-group label="Full Name" label-cols-md="2">
					<b-form-input v-model="search.mbsdFullName"  placeholder="Full name to find" @input="doFilter"></b-form-input>
				</b-form-group>
				<b-pagination-nav
					v-model="currentPage"
					:number-of-pages="maxPage"
					:base-url="'/list/'"
					last-number
					:use-router=useRouter
					align="fill"
					limit=10
					:link-gen="linkGen"
				></b-pagination-nav>
				<b-table striped hover :items="resource.data" :fields="fields">
					<template v-slot:cell(mbsdFullName)="row">
						<b-button size="md" @click="show(row)" class="adminListName">
							<span v-if="members[row.item.links.mbsdZmemId]">{{ row.detailsShowing ? '👁' : '👤'}} {{members[row.item.links.mbsdZmemId].zmemFullName}}</span>
						</b-button>
					</template>
					<!-- <template v-slot:cell(mbsdEmail)="row">
						<b-button size="md" @click="mailTo(row)" class="adminListName">
							{{row.item.mbsdEmail}}
						</b-button>
					</template> -->

					<template v-slot:row-details="row">
						<div v-if="row.item.detail">
							<b-row>
								<b-col v-if="row.item.mbsdStatus==0">
									<b-button block variant="success" class="mb-3" @click="verifyData(row)">Approve Data</b-button>
								</b-col>
								<b-col v-if="row.item.mbsdStatus==0">
									<b-button block variant="warning" class="mb-3" @click="updateProfile(row)">Reject Data</b-button>
								</b-col>
								<b-col v-if="row.item.mbsdStatus==1">
									<b-button block variant="primary" class="mb-3" @click="dataCorrection(row)">Update Data</b-button>
								</b-col>							
							</b-row>

							<b-card v-for="(l,f) in row.item.detail.linked" v-bind:data="l" v-bind:key="f" v-if="l[0]">
								<b-card-title v-if="f=='mregZmemId'">Transaction Info</b-card-title>
								<b-card-title v-if="f=='mmedZmemId'">Additional Info</b-card-title>
								<b-card-title v-if="f=='mbsdZmemId'">Member Info</b-card-title>
								<b-card-title v-if="f=='mbspZmemId'">Phone Info</b-card-title>
								<b-row class="mb-2" v-for="(value, key) in l[0]" v-bind:data="value" v-bind:key="key">
									<b-col sm="5" class="text-sm-right"><b>{{key}}</b></b-col>
									<b-col>{{value}}</b-col>
								</b-row>
								<b-button block variant="primary" class="mb-3" v-if="row.item.mbsdStatus==1&&f=='mregZmemId'&&l[0]&&l[0].mregStatus==0" @click="approveBallot(l[0])">Approve Ballot</b-button>

								<!-- <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button> -->
							</b-card>
							
						</div>
					</template>
					<template v-slot:cell(mbsdFile)="data" >
						<!-- `data.value` is the value after formatted by the Formatter -->
						<!-- <a target="_blank" :href="'https://private.borobudurmarathon.com/view/'+`${data.value}`" style="font-size:8px;letter-spacing:2px;text-transform:uppercase;display:block">{{ data.value }}</a> -->
						<!-- <a target="_blank" :href="'https://private.borobudurmarathon.com/view/'+`${data.value}`"> -->
							<!-- <img :src="'https://private.borobudurmarathon.com/view/'+`${data.value}`" style="max-width:250px"> -->
							<img v-if="data.value" :src="'https://repository.race.id/view/'+`${data.value}`" style="max-width:250px">
						<!-- </a> -->
					</template>
				</b-table>
			</b-col>		
		</b-row>
	</b-container>
</template>
<style lang="stylus">
	.mailEditor {background: white; padding: 10px;}
</style>
<script>
	import GridContainer from './GridContainer.vue'
	export default {
		data() {
			return {
				search : {
					mbsdEmail : null,
					mbsdFullName : null
				},
				filter : {
					// mbsdStatus :false,
				},
				items : undefined,
				signedin : true,
				data: null,
				content: null,
				editorOption: {},
				members: {},
				currentPage: 1,
				useRouter: true,
				itemsPerPage: 10,
				resource: undefined,
				fields : [
					// 'show_details',
					{
						key: "mbsdFullName",
						label: "Full Name"
					},
					{
						key: "mbsdFile",
						label: "Identity File"
					},
					// {
					// 	key: "mbsdEmail",
					// 	label: "E-mail Address"
					// },
					// {
					// 	key: "mbsdPhone",
					// 	label: "Phone"
					// },
					// {
					// 	key: "mbsdGender",
					// 	label: "Gender"
					// },
					// {
					// 	key: "mbsdIDNumberType",
					// 	label: "ID Type"
					// },
					// {
					// 	key: "mbsdIDNumber",
					// 	label: "ID Number"
					// },
					// {
					// 	key: "mbsdBirthDate",
					// 	label: "Birth Date"
					// },
					// {
					// 	key: "mbsdBirthPlace",
					// 	label: "Birth Place"
					// },
					// {
					// 	key: "mbsdNationality",
					// 	label: "Nationality"
					// },
					// {
					// 	key: "mbsdCountry",
					// 	label: "Country"
					// },
					{
						key: "mbsdStatus",
						label: "Status"
					},
					// {
					// 	key: "mbsdCreatedTime",
					// 	label: "Register Time"
					// },
					// {
					// 	key: "mbsdDeleted",
					// 	label: "Is Deleted"
					// },
				]
			}
		},
		watch: {
			page (to, from) {
				// console.log(to, from);
				this.loadItems(to, from)
			}
		},
		computed: {
			page () {
				return Number(this.$route.params.page) || 1
			},
			totalRows(){
				const { lists } = this.$store.state
				return lists[this.resource].status.totalRecords
			},
			// itemsPerPage(){
			// 	return this.$store.state.itemsPerPage
			// },
			maxPage () {
				// return 1;
				// const { itemsPerPage, lists } = this.$store.state
				// console.log('VVVVVVVVVVVVVVVV ',lists[this.resource].status.totalRecords/itemsPerPage);
				return Math.ceil(this.resource.status.totalRecords/this.itemsPerPage) || 1
			},
			hasMore () {
				return this.page < this.maxPage
			}
		},
		components : {
		},
		methods: {
			mailTo(row){
				this.$router.push({
					path : '/maileditor',
					query : {mbsdEmail:row.value}
				});
				console.log(row);
			},
			show(row){
				console.log('Load detail of : ', row.item.links.mbsdZmemId);
				// row.item.detail = {};
				var params = {
					filter : {
						zmemId : row.item.links.mbsdZmemId
					}
				};
				if (!row.item._showDetails){				
					this.$store.dispatch('GETMEMBER', {params:params})
						.then(member=>{
							row.item.detail = member.data;
							row.item._showDetails = false;
							row.item._showDetails = true;
							// console.log(row.item);
						})
				}
				row.toggleDetails();
			},
			// like(value, input) {
			// 	console.log(value,input);
			// 	return value;
			// 	// this.filter.
			// 	// return '%'+value+'%'
			// },
			verifyData(row){
				this.$store.dispatch('VERIFYDATA', {fileId:row.item.mbsdFile})
					.then(s=>{
						row.item.mbsdStatus = 1;
						// this.enabled = false;
						console.log(s);
					})
					.catch(e=>{
						console.log(e);
					})
				console.log(row);
			},
			loadItems (to = this.page, from = -1) {
				console.log('Start loading items page : ', this.page, this.$route.query);
				const params = {
					// resource: this.resource,
					params: {
						pageNumber: this.page,
					}
				};
				if (this.$route.query){
					params.params.filter = this.$route.query;
				}
				this.$bar.start()
				this.$store.dispatch('GETMEMBERS', params)
					.then(members => {
						this.currentPage = this.page;
						// console.log('VVVVVVVV', JSON.stringify(members.data.linked.mbsdZmemId));
						this.resource = members.data;
						this.resource.linked.mbsdZmemId.forEach(member=>{
							this.members[member.id] = member;
							// console.log(member)
						})
						if (this.page < 0 || this.page > this.maxPage) {
							this.$router.replace(`/1`)
							return
						}
						this.transition = from === -1
							? null
							: to > from ? 'slide-left' : 'slide-right'
						this.displayedPage = to
						// this.displayedItems = this.$store.getters.activeItems
						this.$bar.finish()
					})
					.catch(err=>{
						this.resource = {
							data : [],
							status : {
								totalRecords : 0
							}
						};
						this.$bar.finish()
					})
			},
			linkGen(pageNum){
				return {
					path : '/list/'+pageNum,
					query : this.$route.query
				}
			},
			doFilter(){
				for (const key in this.filter) {
					let value = this.filter[key];
					if (!value&&this.filter[key]){
						delete this.filter[key];
					}
				}
				for (const key in this.search) {
					let value = this.search[key];
					if (value){
						this.filter[key] = {
							like : '%'+value+'%'
						}
					} else {
						if (this.filter[key]) delete this.filter[key];
					}
				}
				this.$router.push({query : this.filter});
				this.loadItems(this.page);
			},
			updateProfile(row){
				console.log('Initiate update profile... ', row.item.mbsdFile);
				this.$store.dispatch('CHANGEPROFILE', {data:row.item.mbsdFile})
					.then(s=>{
						this.loadItems(this.page);
						// row.item.mbsdStatus = 1;
						// this.enabled = false;
						console.log(s);
					})
					.catch(e=>{
						console.log(e);
					})

			},
			dataCorrection(row){
				console.log('Go to profile update page... ', row.item.mbsdId);
				this.$router.push({
					path : '/profile/' + row.item.mbsdId
				});
			},
			approveBallot(d){
				console.log('Initiate ballot approval... ', d);
				var r = confirm("Do you want to manually approve ballot, this action is irreversible???");
				if (r == true) {
					this.$store.dispatch('APPROVEBALLOT', {data:d})
						.then(s=>{
							this.loadItems(this.page);
							// row.item.mbsdStatus = 1;
							// this.enabled = false;
							console.log(s);
						})
						.catch(e=>{
							console.log(e);
						})

				} else {
					console.log('Phewwwww....');
				}
			},
		},
		mounted(){
			this.$store.commit('ACTIVATE_ADMIN');
			this.$store.dispatch('CHECK')
				this.loadItems(this.page)
			// this.$store.dispatch('CHECK')
				// .then((checkOut) =>{
				// 	console.log(checkOut);
				// 	this.data = checkOut.data;
				// 	// this.$store.commit('ACTIVATE_ADMIN');
				// 	this.$store.dispatch('GETMEMBERS',{})
				// 		.then(members=>{
				// 			this.items = members.data.data;
				// 			this.resource = members.data;
				// 			console.log('ABC : ', members.data.data);
				// 		});
				// })
				// .catch(err => {
				// 	console.log(err);
				// })
		},
	}
</script>


// WEBPACK FOOTER //
// TableView.vue